import React from 'react'

interface ChatHistoryOffIconProps {
  size?: number
  color?: string
  className?: string
}

export const ChatHistoryOffIcon: React.FC<ChatHistoryOffIconProps> = ({
  size = 32,
  color = '#FFFFFF',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_314_5670)">
        <rect
          width="32"
          height="32"
          rx="16"
          transform="matrix(1 0 0 -1 0 32)"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M16 9H19C21.2091 9 23 10.7909 23 13V19C23 21.2091 21.2091 23 19 23H16"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
        />
        <path
          d="M10 16H18M10 16L13.5 19.5M10 16L13.5 12.5"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_314_5670">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChatHistoryOffIcon
